<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { db } from "@/main";
import ChannelService from "@/plugins/ChannelService.js";

let vh = undefined;
const setVhProperty = () => {
  vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
};

window.addEventListener("resize", () => {
  setVhProperty();
});

setVhProperty();

export default {
  name: "app",
  data() {
    return {
      config: null,
      version: 3, // clientのversionをインクリメントしてデプロイ後に、サーバーのconfig.versionを更新する
    };
  },
  firestore() {
    return {
      config: db.collection("configs").doc("main"),
    };
  },
  mounted() {
    /*
    setTimeout(() => {
      if (this.$store.state.user && !this.config?.isArchive) {
        // チャットボットの設定
        const email = this.$store.state.user.email;
        ChannelService.boot({
          pluginKey: process.env.VUE_APP_CHANNEL_IO_PLUGIN_KEY,
          zIndex: 100,
          profile: {
            name: email.split("@")[0],
            email: email,
          },
        });
      }
    }, 3000);
    */
  },
  watch: {
    "config.version"(to) {
      if (to > this.version) {
        this.$toasted.show("新しいバージョンのサイトが利用可能です", {
          action: {
            text: "更新",
            onClick: () => {
              location.reload(true);
            },
          },
          duration: null,
          closeOnSwipe: false,
        });
      }
    },
  },
};
</script>

<style lang="scss">
/*
@import "./assets/css/buefy.scss";
@import "./assets/css/bulma/elements/button.css";
$red: #d70a27;

html,
body {
  height: 100%;
  width: 100%;
}

html {
  box-sizing: border-box;
  scroll-behavior: smooth;
}

body {
  font-family: "游ゴシック Medium", "游ゴシック体", "Yu Gothic Medium", YuGothic,
    "ヒラギノ角ゴ ProN", "Hiragino Kaku Gothic ProN", "メイリオ", Meiryo,
    sans-serif;
  font-size: 14px;
  margin: 0;
  position: relative;
}

*,
*:before,
*:after {
  box-sizing: inherit;
}

#app {
  background-color: #fff;
  min-height: 100vh;
  min-height: calc(var(--vh, 1vh) * 100);
  position: relative;

  main {
    background-color: #f7f7f7;
    min-height: 100vh;
    min-height: calc(var(--vh, 1vh) * 100);
  }
}

.hero.is-fullheight {
  min-height: 100vh;
  min-height: calc(var(--vh, 1vh) * 100);
}

.iframe-wrapper {
  background: #000;
  width: 100%;
  height: 0;
  position: relative;
  padding-top: 56.25%;
  overflow: hidden;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100% !important;
    height: 100% !important;
  }
}

.has-text-red {
  color: $red !important;
}

.has-background-red {
  background-color: $red !important;
}

.has-border-red {
  border: 1px solid $red;
}

.has-field-red {
  background-color: rgba(229, 50, 68, 0.1);
  caret-color: $red;
  color: $red;
}

.is-borderless {
  border: none !important;
}
*/
</style>
